module.exports = __webpack_public_path__ + "static/media/ic205edit.c0e931df.jpg";